{
  "REGISTER": {
    "TRY_WOOT": "Crear un compte",
    "TITLE": "Registre",
    "TESTIMONIAL_HEADER": "Només cal un pas per avançar",
    "TESTIMONIAL_CONTENT": "Esteu a un pas de captar els vostres clients, retenir-los i trobar-ne de nous.",
    "TERMS_ACCEPT": "En crear un compte, acceptes els nostres <a href=\"https://chat.jarabot.com/terms\">T&C</a> i <a href=\"https://chat.jarabot.com/privacy-policy\">Política de privadesa</a>",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Termes i condicions</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Política de privadesa</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Registra't amb Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Nom de la companyia",
      "PLACEHOLDER": "Enter your company name. eg: Wayne Enterprises",
      "ERROR": "El nom de l'empresa és massa curt."
    },
    "FULL_NAME": {
      "LABEL": "Nom complet",
      "PLACEHOLDER": "Introdueix el teu nom complet. ex: Bruce Wayne",
      "ERROR": "El nom del compte és massa curt"
    },
    "EMAIL": {
      "LABEL": "Email de treball",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Please enter a valid work email address"
    },
    "PASSWORD": {
      "LABEL": "Contrasenya",
      "PLACEHOLDER": "Contrasenya",
      "ERROR": "La contrasenya és massa curta",
      "IS_INVALID_PASSWORD": "Password should contain atleast 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirma la contrasenya",
      "PLACEHOLDER": "Confirma la contrasenya",
      "ERROR": "La contrasenya no coincideix."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registrat correctament",
      "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
    },
    "SUBMIT": "Crear un compte",
    "HAVE_AN_ACCOUNT": "Ja tens un compte?"
  }
}
